export default __webpack_public_path__ + "static/media/diners.773d7b23.svg";